import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { SearchPage } from '@/features/search/search-page';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Recherche globale (ADR 0043) — `GET /search`. Le terme vit dans l'URL : `?q=`. */
export const Route = createFileRoute('/$tenant/search')({
  validateSearch: (search: Record<string, unknown>): { q: string } => ({
    q: typeof search['q'] === 'string' ? search['q'].slice(0, 200) : '',
  }),
  component: SearchRoute,
});

function SearchRoute() {
  const { tenant } = Route.useParams();
  const { q } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  const onQueryChange = useCallback(
    (next: string) => void navigate({ search: { q: next }, replace: true }),
    [navigate],
  );
  return (
    <ConsoleShell tenantId={tenant} crumbs={[{ label: t('search.title') }]}>
      <SearchPage tenantId={tenant} query={q} onQueryChange={onQueryChange} />
    </ConsoleShell>
  );
}
